import { render, staticRenderFns } from "./SistemasSobMedidaNavegantes.vue?vue&type=template&id=56b99c0c&scoped=true"
import script from "./SistemasSobMedidaNavegantes.vue?vue&type=script&lang=js"
export * from "./SistemasSobMedidaNavegantes.vue?vue&type=script&lang=js"
import style0 from "./SistemasSobMedidaNavegantes.vue?vue&type=style&index=0&id=56b99c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b99c0c",
  null
  
)

export default component.exports